// extracted by mini-css-extract-plugin
module.exports = {"redirectModal":"_3EfV-Xo","continueButton":"_3QRWNOG","flagWrapper":"_26G0t6s","location":"_3AGndpP","access":"_2C7B6uh","pokerstarsIcon":"_1tKaUfy","transparent":"_1Id20aa"};